import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import PeerToPeer from "./PeerToPeer";
import WhatisP2P from "./WhatisP2P";
import Unleashing from "./Unleashing";
import PowerfulTradingEngine from "./PowerfulTradingEngine";
import SecureEscrow from "./SecureEscrow";

function PtoPExchange() {
  return (
    <div>
      <Header />
      <PeerToPeer />
      <WhatisP2P />
      <PowerfulTradingEngine />
      <Unleashing />
      <SecureEscrow />
      <Footer />
    </div>
  );
}

export default PtoPExchange;
